import { render, staticRenderFns } from "./SoftVersionIcon.vue?vue&type=template&id=34b887ad&"
import script from "./SoftVersionIcon.vue?vue&type=script&lang=js&"
export * from "./SoftVersionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b887ad')) {
      api.createRecord('34b887ad', component.options)
    } else {
      api.reload('34b887ad', component.options)
    }
    module.hot.accept("./SoftVersionIcon.vue?vue&type=template&id=34b887ad&", function () {
      api.rerender('34b887ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SoftVersionIcon/components/desktop/SoftVersionIcon.vue"
export default component.exports